<template>
  <div v-editable="blok" class="quote">
    <img
      width="25"
      height="21"
      class="quote__quote-icon"
      src="@/assets/icons/blog-quote.svg?url"
      alt="Quotation mark"
    />
    <blockquote class="quote__content">
      <StoryblokComponent
        v-for="childBlok in blok.content"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </blockquote>
    <div class="quote__figcaption">
      <h5 class="quote__name">
        {{ blok.name }}
      </h5>
      <p class="quote__position">
        {{ blok.position }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbBlogQuote } from '@/types'

interface Props {
  blok: SbBlogQuote
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.quote {
  background-color: #f2f8ff;
  padding: 40px;
  border-radius: 16px;

  @media (min-width: $breakpoint-md) {
    padding: 48px;
  }

  &__figcaption {
    text-align: left;
    margin: 24px 0 0;
  }

  &__name {
    margin: 0;
  }

  &__position {
    margin: 0;
  }

  &__quote-icon {
    margin-bottom: 24px;
  }
}
</style>
